export const StarMark = ({ size = 40, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 64 64"
    className={className}
    fill="none"
    aria-hidden="true"
  >
    <ellipse
      cx="32"
      cy="34"
      rx="24"
      ry="9"
      stroke="#F2A900"
      strokeWidth="2.5"
      transform="rotate(-18 32 34)"
      opacity="0.9"
    />
    <polygon
      points="32,12 36.7,25.53 51.02,25.82 39.61,34.47 43.76,48.18 32,40 20.24,48.18 24.39,34.47 12.98,25.82 27.39,25.53"
      fill="#FFC93C"
    />
  </svg>
);

export const Wordmark = ({ onLight = false, className = "" }) => (
  <span className={`font-body font-black tracking-tight ${className}`}>
    <span className={onLight ? "text-brand" : "text-snow"}>entertainment</span>
    <span className={onLight ? "text-gold-deep" : "text-gold"}>shows</span>
    <span className={onLight ? "text-brand" : "text-snow"}>.be</span>
  </span>
);
